import React, { Component } from 'react';

// components
import Number from '../StepContent/Number';
import Inner from '../StepContent/Inner';
import SkillsAndCompetencyTable from './Skils&CompetencyTable';
import {Field} from "redux-form";


class Step1 extends Component {

    validate(value) {
        if(!value)
            return "Required";
    }

    render() {
        let classNames = 'stepA';
        if (this.props.className) {
            classNames += ' stepSucc';
        }

        return (
            <div className={classNames}>
                <Number number='01' className="stepNumber--first"/>
                <Inner>
                    <h3>Sector & <span>competency</span></h3>
                    <Field validate={[this.validate]} name={"skills"} custom={this.props} component={SkillsAndCompetencyTable}/>
                </Inner>
            </div>
        );
    }
}

export default Step1;



// WEBPACK FOOTER //
// ./src/components/Membership/Step1/index.js